module.exports = __webpack_public_path__ + "static/media/filter.7c873b0f.svg";